const SvgStainResistant = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 33 32">
    <mask id="stainResistant_svg__a" width={33} height={32} x={0} y={0} maskUnits="userSpaceOnUse" style={{
    maskType: 'luminance'
  }}>
      <path fill="#fff" d="M32.5 0H.5v32h32z" />
    </mask>
    <g mask="url(#stainResistant_svg__a)">
      <path fill="#373737" d="M19.56 3.798a.42.42 0 0 0-.593.09l-4.153 5.629q-.087.105-.173.22c-1.613 2.186-1.232 5.217.777 6.97l-5.702 7.728c-2.925-2.006-4.153-.905-4.153-.905l6.924 5.11s.691-1.5-2.09-3.702l5.697-7.719a5.14 5.14 0 0 0 3.494.733 5.16 5.16 0 0 0 3.402-2.051l4.32-5.856a.4.4 0 0 0 .077-.314.42.42 0 0 0-.167-.278zm2.751 11.6a4.35 4.35 0 0 1-6.073.916 4.35 4.35 0 0 1-.759-6.276l3.917-5.308 6.982 5.152-4.07 5.516z" />
      <path fill="#373737" d="M16.807 15.543a3.54 3.54 0 0 0 4.954-.75l3.235-4.204h-8.934a3.54 3.54 0 0 0 .748 4.954z" />
      <path fill="#373737" d="M32.5 1.597V0H.5v32h32V1.597m-1.709 21.078v7.62H2.21V1.708H30.79v20.969z" />
      <path stroke="#fff" strokeWidth={3} d="M2 1.5h29v30H2z" />
    </g>
  </svg>;
export default SvgStainResistant;